"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

/* eslint-disable max-len */
var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  stroke: "currentColor",
  fill: "currentColor",
  strokeWidth: "0",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  height: "14",
  width: "14",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    display: 'inline-block',
    width: '1em',
    height: '1em',
    verticalAlign: 'middle',
    userSelect: 'none'
  }
}, /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M856 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zM656 112H192c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM392 840H232V664h160v176z m0-240H232V424h160v176z m0-240H232V184h160v176z m224 480H456V664h160v176z m0-240H456V424h160v176z m0-240H456V184h160v176z"
}));

exports["default"] = _default;
//# sourceMappingURL=insertColumn.js.map